(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.resource-card__add-to-cart');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    button.disabled = true;
    const originalLabel = button.querySelector('span').textContent;
    button.querySelector('span').textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to add to cart');
        return response.json();
      })
      .then(() => {
        button.querySelector('span').textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(() => {
          button.querySelector('span').textContent = originalLabel;
          button.disabled = false;
        }, 1500);
      })
      .catch(() => {
        button.querySelector('span').textContent = originalLabel;
        button.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
